import React, { memo } from 'react';
import type {
	GroupItemsQueryControllerProps,
	GroupByFieldId,
} from '../../../services/get-item-groups/types';
import { getGroupQuery } from '../../../services/get-item-groups/utils';
import type { ListViewIssue } from '../../../services/get-list-view-issues/types';
import { GroupItemsQueryController } from '../../group-items-query';

type GroupItemsControllerProps = {
	expandedGroupItemIssueIds: string[];
	groups: ListViewIssue[];
	groupByFieldId: GroupByFieldId;
	onDataChange: GroupItemsQueryControllerProps['onDataChange'];
};

export const GroupItemsController = memo<GroupItemsControllerProps>(
	({ expandedGroupItemIssueIds, groupByFieldId, groups, onDataChange }) => (
		<>
			{expandedGroupItemIssueIds.map((expandedGroupItemIssueId) => {
				const groupQuery = getGroupQuery({
					groups,
					groupIssueId: expandedGroupItemIssueId,
					groupByFieldId,
				});
				if (!groupQuery) {
					return null;
				}
				return (
					<GroupItemsQueryController
						groupIssueId={expandedGroupItemIssueId}
						onDataChange={onDataChange}
						key={expandedGroupItemIssueId}
						groupQuery={groupQuery}
					/>
				);
			})}
		</>
	),
	// Only re-render when expandedGroupItemIssueIds or onDataChange changes
	(prevProps, nextProps) => {
		const prevIssueIds = prevProps.expandedGroupItemIssueIds.sort();
		const nextIssueIds = nextProps.expandedGroupItemIssueIds.sort();

		return (
			prevProps.onDataChange === nextProps.onDataChange &&
			prevIssueIds.length === nextIssueIds.length &&
			prevIssueIds.every((_, id) => prevIssueIds[id] === nextIssueIds[id])
		);
	},
);
